// Pure helpers for super-admin "View as user" (spec B4).
import jwtDecode from 'jwt-decode'
import { ROLE_SUPER_ADMIN } from '../enums/roles'

export const IMPERSONATOR_TOKEN_KEY = 'impersonatorAccessToken'
export const IMPERSONATOR_USER_KEY = 'impersonatorUserData'
export const IMPERSONATOR_SESSION_KEY = 'impersonatorSessionId'
export const EXIT_PATH = '/impersonation/exit'

// Same as Utils.generateSubdomainUrl (Utils pulls UI modules jest cannot resolve).
const subdomainUrl = (subDomain, path) => `${process.env.REACT_APP_URL.replace('app', subDomain)}${path}`

// Apps that accept impersonation tokens (connect/teamgpt reject them, spec B3).
const VIEWABLE_APPS = ['bravo']
const FALLBACK_APP = 'bravo'

export const claimsFromToken = (token) => {
  if (!token) return null
  try {
    return jwtDecode(token)
  } catch (e) {
    return null
  }
}

export const impersonationInfo = (claims) => {
  if (!claims?.impersonationId) return null
  const { impersonationId, fullName, email, exp } = claims
  return { impersonationId, name: fullName, email, exp }
}

export const remainingSeconds = (exp, nowMs) => Math.max(0, Math.floor(exp - (nowMs / 1000)))

const pad = (n) => String(n).padStart(2, '0')

export const formatCountdown = (seconds) => `${pad(Math.floor(seconds / 60))}:${pad(seconds % 60)}`

const roleName = (role) => (typeof role === 'string' ? role : role?.name)

export const canViewAsUser = (user) => {
  if (!user || user.isSuperAdmin) return false
  return !(user.roles || []).map(roleName).includes(ROLE_SUPER_ADMIN)
}

export const isValidReason = (reason) => (reason || '').trim().length >= 10

export const landingUrl = (company) => {
  const alias = company?.defaultApplication?.alias
  const app = VIEWABLE_APPS.includes(alias) ? alias : FALLBACK_APP
  return subdomainUrl(company.subDomain, `/${app}/`)
}

export const exitUrl = () => subdomainUrl('app', `${process.env.REACT_APP_BASENAME || ''}/companies`)

export const isExitPath = (pathname) => (pathname || '').replace(/\/+$/, '').endsWith(EXIT_PATH)

// Roles for the merged session in AppPermissions. Normal sessions keep the cached local roles
// (existing behaviour); an impersonation session must never inherit them, since localStorage on a
// company subdomain can still hold a super admin's roles from an earlier visit.
export const sessionRoles = (localUserData, tokenClaims) => {
  if (impersonationInfo(tokenClaims)) return tokenClaims.roles || []
  return localUserData ? localUserData.roles : []
}
